
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Courses from "../pages/courses/page";
import WallOfFame from "../pages/wall-of-fame/page";
import WorkWithUs from "../pages/work-with-us/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/wall-of-fame",
    element: <WallOfFame />,
  },
  {
    path: "/work-with-us",
    element: <WorkWithUs />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
